<template>
  <div class="mobile-view">
    <div class="bg"></div>
    <div class="content">
      <div class="banner">
        <img
          src="https://ustatic.hudongmiao.com/miao/common/bar-banner-mobile_1768988553836fd653b.webp"
          alt="banner"
        />
      </div>
      <mobile-content1 />
      <mobile-content2 />
      <mobile-content3 />
      <mobile-content4 />
      <div class="go-container">
        <div class="go-btn">
          立即开启智能酒吧之旅
        </div>
      </div>
      <mobile-content5 />
    </div>
  </div>
</template>

<script>
import MobileContent1 from './mobileContent1.vue';
import MobileContent2 from './mobileContent2.vue';
import MobileContent3 from './mobileContent3.vue';
import MobileContent4 from './mobileContent4.vue';
import MobileContent5 from './mobileContent5.vue';

export default {
  name: 'MobileView',
  components: {
    MobileContent1,
    MobileContent2,
    MobileContent3,
    MobileContent4,
    MobileContent5,
  },
};
</script>

<style lang="less" scoped>
.mobile-view {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  padding-bottom: 47px;

  .bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background-image: url('https://ustatic.hudongmiao.com/miao/common/mobile-bg2_1768991825480a81656.webp');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 0;
  }

  .content {
    position: relative;
    z-index: 1;
  }

  .banner {
    width: 100%;

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  .go-container {
    width: 659px;
    height: 115px;
    margin: 48px auto 40px;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(
      90deg,
      rgba(111, 40, 149, 0.8) 0%,
      rgba(78, 33, 186, 0.8) 100%
    );

    .go-btn {
      width: 329px;
      height: 47px;
      border-radius: 28px;
      background: linear-gradient(90deg, #CD5DFB 0%, #7249FF 100%);
      box-shadow: inset 0px 4px 10px 0px rgba(255, 255, 255, 0.6);
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      font-size: 22px;
      color: #FFFFFF;
    }
  }
}
</style>
